import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InvoiceSimulationDTO from "features/contracts/dtos/InvoiceSimulationDTO";
import RoundButton from "features/shared/components/buttons/RoundButton";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./invoicesimulation.module.scss";

interface Props {
  invoiceSimulation: InvoiceSimulationDTO;
}

const InvoiceSimulation = (props: Props) => {
  // translations
  const tLabels = useTranslation("invoiceSimulation\\invoiceSimulation").t;

  // HELPERS
  const detailLink = `invoice-simulation/detail/${props.invoiceSimulation.invoiceSimulationId}`;

  const getPriceClass = () => {
    const {totalAmount} = props.invoiceSimulation;
    return totalAmount! > 0 ? "text-price" : "text-success"; 
  }

  // RENDER
  return (
    <div className="row align-items-center no-gutters">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm-3 col-xl-2 mb-1 mb-sm-0">
            <div className="row no-gutters">
              <div className="d-flex flex-sm-column">
                <span className="mr-2 mr-lg-0 text-truncate">
                  <span className="mr-1 text-muted">
                    <FontAwesomeIcon
                      icon="hourglass-start"
                      size="xs"
                      fixedWidth
                    />
                  </span>
                  <span className="small">
                    <DateFormatter date={new Date(props.invoiceSimulation.periodFrom!)} />
                  </span>
                </span>
                <span className="text-truncate">
                  <span className="mr-1 text-muted">
                    <FontAwesomeIcon
                      icon="hourglass-end"
                      size="xs"
                      fixedWidth
                    />
                  </span>
                  <span className="small">
                    <DateFormatter
                      date={new Date(props.invoiceSimulation.periodTo!)}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="col-sm-3 col-xl-2">
            <div className="row no-gutters">
              <div className={`col-auto d-sm-none text-muted pr-2 ${styles.itemLabel}`}>{tLabels("invoiceSimulation.calculation")}:</div>
              <div>
                <DateFormatter
                  date={props.invoiceSimulation.calculationDate!}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-3 col-xl-5 pr-2">
            <div className="row no-gutters">
              <div className="col-xl-6">
                <div className="row no-gutters">
                  <div className={`col-auto d-sm-none text-muted pr-2 ${styles.itemLabel}`}>{tLabels("invoiceSimulation.amount")}:</div>
                  <div className="col text-truncate">
                    <PriceFormatter
                      amount={props.invoiceSimulation.taxIncusiveAmount!}
                      currency={props.invoiceSimulation.currency!}
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="row no-gutters">
                  <div className={`col-auto d-sm-none text-muted pr-2 ${styles.itemLabel}`}>{tLabels("invoiceSimulation.advance")}:</div>
                  <div className="col text-truncate">
                    <PriceFormatter
                      amount={props.invoiceSimulation.advance!}
                      currency={props.invoiceSimulation.currency!}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3 col-xl-3 text-truncate">
            <div className="row no-gutters">
              <div className={`col-auto d-sm-none text-muted pr-2 ${styles.itemLabel}`}>{tLabels("invoiceSimulation.difference")}:</div>
              <div className={`col text-truncate ${getPriceClass()}`}>
                <PriceFormatter
                  amount={props.invoiceSimulation.totalAmount!}
                  currency={props.invoiceSimulation.currency!}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto pl-2">
        <RoundButton asLink to={detailLink} />
      </div>
    </div>
  );
};

export default InvoiceSimulation;